import { useState } from 'react'
import { watchLaterMutation } from 'app/mutations/content/toggle-watch-later'
import useRequester from './use-requester'
import { useQueryClient } from 'react-query'

interface UseToggleWatchLaterOptions {
  skipListInvalidation?: boolean
}

export const useToggleWatchLater = ({ skipListInvalidation = false }: UseToggleWatchLaterOptions = {}) => {
  const { request } = useRequester()
  const queryClient = useQueryClient()
  const [mutating, setMutating] = useState<Record<string, boolean>>({})
  const watchLater = watchLaterMutation()

  const toggleWatchLater = async (id: string) => {
    setMutating((prev) => ({ ...prev, [id]: true }))
    try {
      const result = await request(watchLater, { id })
      if (!skipListInvalidation) {
        queryClient.invalidateQueries('watch-later')
      }
      queryClient.invalidateQueries('watch-later-batch')
      return result
    } catch (error) {
      console.error('Error toggling watch later:', error)
      throw error
    } finally {
      setMutating((prev) => ({ ...prev, [id]: false }))
    }
  }

  const isMutating = (id: string) => mutating[id] || false

  return {
    toggleWatchLater,
    isMutating,
  }
}
